export const REMEMBER_ME_ELIGIBLE_KEY = 'cc_canUseRememberMe';

export function setRememberMeEligible(eligible) {
  if (eligible) {
    localStorage.setItem(REMEMBER_ME_ELIGIBLE_KEY, 'true');
  } else {
    localStorage.removeItem(REMEMBER_ME_ELIGIBLE_KEY);
  }
}

export function isRememberMeEligible() {
  return localStorage.getItem(REMEMBER_ME_ELIGIBLE_KEY) === 'true';
}

export function clearRememberMeEligible() {
  localStorage.removeItem(REMEMBER_ME_ELIGIBLE_KEY);
}
